import request from '@/config/axios'

export interface DistApplyVO {
  id?: number
  userId?: number
  userNickname?: string
  realName?: string
  mobile?: string
  idCardFrontUrl?: string
  idCardBackUrl?: string
  feeAmount?: number
  tradeOrderId?: number
  status?: number
  rejectReason?: string
  paidTime?: string
  auditTime?: string
  passTime?: string
  createTime?: string
}

export const getDistApplyPage = (params: {
  pageNo?: number
  pageSize?: number
  status?: number
  userId?: number
}) => request.get<{ list: DistApplyVO[]; total: number }>({ url: '/bosscircle/dist-apply/page', params })

export const auditDistApply = (data: { id: number; pass: boolean; rejectReason?: string }) =>
  request.put({ url: '/bosscircle/dist-apply/audit', data })
